import i18n from "i18next";
import { faScroll } from "@fortawesome/pro-regular-svg-icons";
import { EmailTemplate } from "src/api/generated/erp/db/types/tables/emailTemplate.ts";
import { EmailTemplateQueryApi } from "src/api/generated/common/mail/emailTemplate/api/emailTemplateQueryApi.ts";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import { useInputDialog } from "src/components/common/dialogs/input/useInputDialog.tsx";

export interface EmailTemplateSelectButtonProps {
	onTemplateSelected: (template: EmailTemplate) => void;
}

export const EmailTemplateSelectButton = ({ onTemplateSelected }: EmailTemplateSelectButtonProps) => {
	const showInputDialog = useInputDialog();

	return <AsyncButton label={i18n.t("import_from_template")} icon={faScroll} onClick={onClick} />;

	async function onClick() {
		const templates = await EmailTemplateQueryApi.getEmailTemplateOptions();
		const emailTemplateId = await showInputDialog({
			type: "singleNumberSelect",
			title: i18n.t("select_email_template"),
			fieldLabel: i18n.t("email_template"),
			defaultValue: null,
			required: true,
			fieldProps: {
				selection: {
					options: templates.map((t) => ({ value: t.emailTemplateId, label: t.name })),
				},
			},
		});
		if (emailTemplateId == null) return;

		const template = templates.find((t) => t.emailTemplateId === emailTemplateId);
		if (template == null) return;
		onTemplateSelected(template);
	}
};
